import React from 'react';
import Layout from '@/common/Layout';
import TrackerListPage from './components/TrackerListPage';

const ActivityTracker = () => {
  return (
    <>
      <Layout sider={false}>
        <TrackerListPage />
      </Layout>
    </>
  );
};

export default ActivityTracker;
